import { Box, Button, TextField, Typography } from '@mui/material';
import Grid2 from '@mui/material/Grid2';
import { inputStyles } from '../styles';
import { useSettings } from '../../hooks/useSettings';

interface SettingFormProps {
  isEditMode?: boolean;
  editingSettingLabel?: string;
}

const SettingForm = ({
  isEditMode,
  editingSettingLabel,
}: SettingFormProps = {}) => {
  const {
    newSettingData,
    newSettingErrors,
    handleNewSettingChange,
    setShowAddSetting,
    addNewSetting,
    isSettingEditMode,
    editingSetting,
  } = useSettings();

  // Use props if provided, otherwise use values from context
  const effectiveIsEditMode =
    isEditMode !== undefined ? isEditMode : isSettingEditMode;
  const effectiveEditingLabel =
    editingSettingLabel || (editingSetting ? editingSetting.uiLabel : '');
  return (
    <Grid2
      container
      spacing={2}
      size={12}
      sx={{
        mt: effectiveIsEditMode ? 1 : 3,
        mb: effectiveIsEditMode ? 2 : 0,
        p: 2,
        backgroundColor: 'rgba(0, 0, 0, 0.1)',
        borderRadius: '4px',
      }}
    >
      <Grid2 size={12}>
        <Typography variant='h6' gutterBottom>
          {effectiveIsEditMode
            ? `Edit Setting "${effectiveEditingLabel}"`
            : 'Add New Setting'}
        </Typography>
      </Grid2>

      <Grid2 size={6}>
        <TextField
          fullWidth
          label='Setting Label'
          name='uiLabel'
          value={newSettingData.uiLabel}
          onChange={handleNewSettingChange}
          variant='outlined'
          size='small'
          error={!!newSettingErrors['uiLabel']}
          helperText={newSettingErrors['uiLabel']}
          sx={inputStyles}
        />
      </Grid2>

      <Grid2 size={6}>
        <TextField
          fullWidth
          label='Controller Field'
          name='controllerField'
          value={newSettingData.controllerField}
          onChange={handleNewSettingChange}
          variant='outlined'
          size='small'
          error={!!newSettingErrors['controllerField']}
          helperText={newSettingErrors['controllerField']}
          sx={inputStyles}
        />
      </Grid2>

      <Grid2 size={12} sx={{ mt: 2 }}>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
          <Button
            variant='outlined'
            color='primary'
            onClick={() => setShowAddSetting(false)}
          >
            Cancel
          </Button>
          <Button variant='contained' color='primary' onClick={addNewSetting}>
            {effectiveIsEditMode ? 'Save' : 'Add Setting'}
          </Button>
        </Box>
      </Grid2>
    </Grid2>
  );
};

export default SettingForm;
